import { Component, OnInit, Input } from '@angular/core';
import { PolicyService } from 'app/services/policy-service';

@Component({
    selector: 'app-product-pagination',
    templateUrl: './product-pagination.component.html',
    styleUrls: ['./product-pagination.component.scss']
})
export class ProductPaginationComponent implements OnInit {

    @Input() loading: Boolean;
    @Input() response: any;

    constructor(private policyService: PolicyService) { }

    ngOnInit() {
    }

    onChange(value) {
        this.policyService.setPageSize(value);
    }

    start(): String {
        return this.response.pageable.offset + 1;
    }

    end(): String {
        if (!this.response.last) {
            return this.response.pageable.offset + this.response.pageable.pageSize
        } else {
            return this.response.totalElements;
        }
    }

    total(): String {
        return this.response.totalElements;
    }

    prev() {
        if (!this.loading && !this.response.first) {
            this.policyService.setPageOffset(this.response.number - 1);
        }
    }

    next() {
        if (!this.loading && !this.response.last) {
            this.policyService.setPageOffset(this.response.number + 1);
        }
    }

    showPagination(): Boolean {
        return this.response.totalElements > 5;
    }

}

